'use client'

import dynamic from 'next/dynamic'
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'
import type { Media } from '@/payload-types'

const ClientHeroParallax = dynamic(() => import('@/components/ui/ClientHeroParallax'))

type Product = {
  title: string
  link: string
  thumbnail: string | Media
}

type Props = {
  heading: SerializedEditorState
  description?: string
  products: Product[]
}

const ClientWrapper = ({ heading, description, products }: Props) => {
  return <ClientHeroParallax heading={heading} description={description} products={products} />
}

export default ClientWrapper
